export enum LoginBehaviors {
  PlainLogin = 1,
  SSOAndPlainLogin = 2,
  SSO = 3
}
